<div class="ep_card">
  <div
    class="ep_card-header ep_card-header-icon"
    [ngClass]="'ep_card-header-warning'"
  >
    <div class="ep_card-icon">
      <i class="material-icons">{{
        icons[currentIndex]
      }}</i>
    </div>
    <p class="ep_card-category">
      {{ titles[currentIndex] }}
    </p>
  </div>

  <mat-tab-group
    (selectedTabChange)="currentIndex = $event.index"
  >
    <mat-tab label="Rendiconto Editore">
      <generate-report
        [user]="user"
        type="ep_card-header-warning"
        title="Rendiconto Editore"
        onlyCardBody="true"
      ></generate-report
    ></mat-tab>
    <mat-tab label="Rendimento magazzino">
      <div
        class="ep_card-footer row"
        *ngIf="!this.loadingObj.editori"
      >
        <div
          class="col-4"
          *ngIf="!isEditore"
        >
          <mat-form-field class="full-width">
            <mat-label>Seleziona un editore</mat-label>
            <mat-select [(ngModel)]="selected.editore">
              <mat-option [value]="0">Tutti</mat-option>
              <mat-option
                *ngFor="let item of editori"
                [value]="item.cod"
              >
                {{ item.descrizione }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div ngClass="isEditore ? 'col-12' : 'col-4'">
          <mat-form-field class="full-width">
            <mat-label>Seleziona un anno</mat-label>
            <mat-select [(ngModel)]="selected.anno">
              <mat-option
                *ngFor="let item of anni"
                [value]="item.cod"
              >
                {{ item.descrizione }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-4" *ngIf="selected.anno">
          <mat-form-field class="full-width">
            <mat-label>Seleziona un mese</mat-label>
            <mat-select [(ngModel)]="selected.mese">
              <mat-option
                *ngFor="let item of mesi"
                [value]="item.id"
              >
                {{ item.mese }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="this.loadingObj.editori">
        <mat-spinner
          [diameter]="20"
          color="accent"
        ></mat-spinner>
      </div>

      <button
        mat-raised-button
        color="primary"
        style="
          margin: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        *ngIf="selected.mese"
        (click)="downloadReport()"
      >
        <ng-container
          *ngIf="this.loadingObj.download; else textBtn"
        >
          <mat-spinner
            [diameter]="20"
            color="accent"
          ></mat-spinner>
        </ng-container>
        <ng-template #textBtn>
          Scarica rendimento
        </ng-template>
      </button></mat-tab
    >
  </mat-tab-group>
</div>
